import { jsx as e } from "react/jsx-runtime";

import l from "../../../utils/classNames/index.js";

const a = ({children: a, className: r, ...s}) => e("div", {
    ...s,
    className: l("px-m gap-s typography-body-l text-neutral flex flex-col flex-wrap", r, "h-full overflow-y-auto"),
    children: a
});

export { a as default };
//# sourceMappingURL=index.js.map
